const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const StudentLink = require("../../core/view/StudentLink");
const Sounds = require("../../core/util/Sounds");
const Colors = require("../../core/util/ColorUtil").getCurrentScheme();

const styles = require("./styles/BlockStar.css");

module.exports = createReactClass({
	displayName: "BlockStar",

	propTypes: {
		className: PT.string,
		clickSound: PT.string,
		// star-0 = unearned
		type: PT.oneOf([
			"star-0",
			"star-1",
			"star-2",
			"star-3",
			"trophy-earned",
			"trophy-unearned",
			"moon",
			"comet",
			"planet",
			"galaxy",
		]),
		celestialEarned: PT.bool,
		shadowOffset: PT.oneOf([2, 3]),
		onClick: PT.func,
		linkTo: PT.string,
		showHoverEffect: PT.bool,
	},

	getDefaultProps: function() {
		return {
			shadowOffset: 3,
			showHoverEffect: true,
		};
	},

	getInitialState: function() {
		return {
			isHovering: false,
		};
	},

	onHoverStart: function() {
		this.setState({isHovering: true});
	},

	onHoverEnd: function() {
		this.setState({isHovering: false});
	},

	makeImg: function(isShadow) {
		const {type, celestialEarned} = this.props;
		let starImg;
		const cs = isShadow
			? {
					number: "#000000",
					highlight: "#000000",
					base: "#000000",
					opacity: "0.4",
			  }
			: {
					number: "#d39519",
					highlight: "#b8883f",
					base: Colors.iconYellow,
					opacity: "1",
			  };
		const tcs = isShadow
			? {
					main: "#000000",
					highlight: "#000000",
					shade: "#000000",
					white: "#000000",
			  }
			: {
					main: Colors.iconYellow,
					highlight: "#ffeb9c",
					shade: "#d39519",
					white: "#FFFFFF",
			  };

		let st1, st3, st4;
		if (isShadow) {
			st1 = {
				fill: "#000000",
				opacity: 0.4,
			};
			st3 = st1;
			st4 = st1;
		} else {
			st1 = {
				fill: Colors.iconYellow,
				opacity: 1,
			};
			st3 = {
				fill: "#FFFFFF",
				opacity: 0.6,
			};
			st4 = {
				fill: "#FFECA1", // light yellow
				opacity: 1,
			};
		}
		if (type === "star-0") {
			starImg = (
				<svg
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
					className={styles.svg}
				>
					<g>
						<path
							fill={isShadow ? cs.base : "#FFFFFF"}
							opacity={isShadow ? cs.opacity : "0.6"}
							d="M28.56,25.58,31.4,37.26,20.31,31,8.11,36.82l3.3-12.5L1.86,16.76l12.63-2.1L20.82,2.29l5.63,13.82,12.08,2.6Z"
						/>
					</g>
				</svg>
			);
		} else if (type === "star-1") {
			starImg = (
				<svg
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
					opacity={cs.opacity}
					className={styles.svg}
				>
					<g>
						<ellipse
							fill={cs.number}
							cx="20.19"
							cy="21.97"
							rx="9.4"
							ry="8.63"
						/>
						<polygon
							fill={cs.highlight}
							points="21.78 25.71 21.55 26.64 26.05 26.5 25.95 25.13 25.1 24.71 23.06 24.82 21.78 25.71"
						/>
						<path
							fill={cs.highlight}
							d="M19.35,18.07l1-1.54-.86,10.13-4.16-.94-.5,3s-1.31-.66-1.27-1.2A35.73,35.73,0,0,1,13.87,24c.12,0,2.39-.31,2.47-.42s1.54-2.66,1.62-2.9S19.35,18.07,19.35,18.07Z"
						/>
						<polyline
							fill={cs.highlight}
							points="15.17 19.13 19.8 15.16 23.21 15.06 23.09 13.55 19.43 13.52 14.84 16.25 12.98 18.57 14.87 18.8"
						/>
						<polygon
							fill={cs.highlight}
							points="20.77 2.41 21.41 2 28.46 17.56 26.24 17.87 22.57 12.79 21.07 10.2 20.77 2.41"
						/>
						<path
							fill={cs.highlight}
							d="M37.15,18.62l1.37.09.51.52-9.38,7.06,2.58,11.66L30,36.12,26.32,30s-.08-4.5,0-4.83,1.75-3.83,1.92-4.08,5.42-2,5.42-2Z"
						/>
						<path
							fill={cs.highlight}
							d="M20.33,29.67,22.75,31,8,37.67l.22-1.14s7.3-6.6,7.52-6.76A46.33,46.33,0,0,1,20.33,29.67Z"
						/>
						<polygon
							fill={cs.highlight}
							points="12.04 24.2 11.61 26.61 1.1 16.9 2.05 16.78 10.26 19.43 12.04 24.2"
						/>
						<path
							fill={cs.base}
							d="M28.56,25.58,31.4,37.26,20.31,31,8.11,36.82l3.3-12.5L1.86,16.76l12.63-2.1L20.82,2.29l5.63,13.82,12.08,2.6Zm-9.68.16-4-.6L14.3,28l11,.83.19-3.15L21.68,26l1-11.69-3.1.25L15.2,18.31l1.95,2.16,2.54-3-.81,8.25"
						/>
					</g>
				</svg>
			);
		} else if (type === "star-2") {
			starImg = (
				<svg
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
					opacity={cs.opacity}
					className={styles.svg}
				>
					<g>
						<ellipse
							fill={cs.number}
							cx="19.62"
							cy="22.27"
							rx="9.02"
							ry="8.89"
						/>
						<path
							fill={cs.highlight}
							d="M21.56,2.87l.79-.57,4.8,13.12-1.31,1.5s-1.41-.75-1.6-1.22S21.8,11,21.8,11Z"
						/>
						<path
							fill={cs.highlight}
							d="M38.81,15.73l1.12.44L30.44,25,33.7,37.32l-1.92-.91S26.87,29,26.87,28.56V22.65s2.82-4,3.1-4.22S38.81,15.73,38.81,15.73Z"
						/>
						<path
							fill={cs.highlight}
							d="M22.37,31.56,7.76,37l0-1s10.71-6.66,11-6.66A39.41,39.41,0,0,1,22.37,31.56Z"
						/>
						<polygon
							fill={cs.highlight}
							points="11.52 25.78 0.78 14.45 1.73 13.9 10.92 19.92 12.32 23.3 11.52 25.78"
						/>
						<polygon
							fill={cs.highlight}
							points="25.5 26.28 17.65 26.92 21.26 24.74 26.6 23.24 25.5 26.28"
						/>
						<path
							fill={cs.highlight}
							d="M21.13,19.36s0,1.71-2.87,4.46c-1.06,1-2.2,2.36-2.2,2.36V30.3l-1.39,0-.75-2.25-.08-3.33a25.6,25.6,0,0,1,1.67-2.33c.25-.17,2.83-2.33,2.83-2.33Z"
						/>
						<path
							fill={cs.highlight}
							d="M15.51,19.47a6.81,6.81,0,0,1,3.71-3.25c1.73-.53,3.16-.47,4.37.75,2.35,2.35-1.16,6.28-1.16,6.28a22.2,22.2,0,0,0,1.94-1.75c0-.18,1.07-2.28,1.07-2.46S25,15.81,25,15.81s-2.5-1.74-2.64-1.74a11.74,11.74,0,0,0-2.64-.13c-.49.18-2.06.49-2.24.54s-1,.94-1.12.94a25.27,25.27,0,0,0-1.83,2.06l-.76.58Z"
						/>
						<path
							fill={cs.base}
							d="M37.52,17.14,28.7,24.55l4,12.34L20.23,31.15l-12.48,5,3.07-12.9-9.2-9.37L15,14.16,21.57,2.83l4.25,12.08,13.06.81ZM24.45,19.67c.65-2.1-.47-4.5-3.58-4.4a7.79,7.79,0,0,0-5.59,3l1.44,1.83a8.68,8.68,0,0,1,2.38-2.05c1.75-.73,3.63.59,2.31,2.26-.94,1.2-6.08,5.63-6.08,5.63l-.07,2.92,8.84-.05L25,25.48l-6.39.89S23.82,21.71,24.45,19.67Z"
						/>
					</g>
				</svg>
			);
		} else if (type === "star-3") {
			starImg = (
				<svg
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
					opacity={cs.opacity}
					className={styles.svg}
				>
					<g>
						<ellipse
							fill={cs.number}
							cx="20.14"
							cy="21.87"
							rx="9.19"
							ry="8.51"
						/>
						<path
							fill={cs.highlight}
							d="M24.8,24.53a5.52,5.52,0,0,0-2.45-1.79,7.39,7.39,0,0,0-1.78-.25,11.28,11.28,0,0,1,1.66-.88,5.16,5.16,0,0,1,1.59.2A15.08,15.08,0,0,1,24.8,24.53Z"
						/>
						<path
							fill={cs.highlight}
							d="M21.38,18.05s.86,1.32-.79,2.58c-.83.63-4.18,1-4.18,1s-.32-1.18-.05-1.25a10.21,10.21,0,0,0,1.45-1.12Z"
						/>
						<path
							fill={cs.highlight}
							d="M21.51,24.14a1.1,1.1,0,0,1,.6,1.59c-.53,1.19-2.23,1.47-3.82,1.33a12.93,12.93,0,0,1-3.51-1.17l.58-1.29s1.32-.26,1.59-.26S21.51,24.14,21.51,24.14Z"
						/>
						<path
							fill={cs.highlight}
							d="M15.18,18.5s1.9-2.91,4.53-3.23c2.86-.35,3.78.63,4.65,1.72.38.48.73.86.73.86s-.13-1.52-.13-1.79a19.77,19.77,0,0,0-1.52-2.45l-2.24.19-2.44.1-3.58,1.69L13.78,17Z"
						/>
						<polygon
							fill={cs.highlight}
							points="20.61 2.82 27.2 15.16 25.56 16.29 24.08 13.59 21.29 8.08 20.61 2.82"
						/>
						<path
							fill={cs.highlight}
							d="M38.38,14.92,29.8,24.41,32,37.4,30.63,35s-1.52-5.63-1.52-5.88-2-6-2-6l2-1.16,4.67-4.37Z"
						/>
						<polygon
							fill={cs.highlight}
							points="21.91 31.2 6.76 36.5 7.44 35.01 19.88 29.33 21.91 31.2"
						/>
						<path
							fill={cs.highlight}
							d="M3.62,15.42,2.16,15s9.31,11,9.39,10.73.53-3.5.53-3.5l-.79-.68Z"
						/>
						<path
							fill={cs.base}
							d="M28.28,23.87,32,37.31,19.53,30.4,6.66,36.47l5-12.65L2.16,15l12.9-.67L20.53,2.54l5,12.17,12.85.22ZM16.34,19.23a8.68,8.68,0,0,1,2.48-1.92c1.79-.64,3.59.77,2.19,2.38-1,1.15-3.83,1.06-3.83,1.06l0,2.5a9.52,9.52,0,0,1,2.63-.2c2.06.39,3.58,2.41.71,3.18a6,6,0,0,1-4.63-.74l.32,3.38a10.19,10.19,0,0,0,4.12.2c2.76-.33,4.78-1.79,4.32-4.17s-3.2-2.93-3.2-2.93a5.17,5.17,0,0,0,2.67-2.78c.76-2.06-.23-4.52-3.35-4.58A7.79,7.79,0,0,0,15,17.33Z"
						/>
					</g>
				</svg>
			);
		} else if (type === "trophy-earned") {
			starImg = (
				<svg
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
					opacity={cs.opacity}
					className={styles.svg}
				>
					<g>
						<path
							fill={tcs.main}
							d="M38.23,4.15l-10,.3c.12-1.05.18-1.69.18-1.69H10.82s0,.85.05,2.21l-9.45.28s1.12,12.46,13,15a8.9,8.9,0,0,0,1.78,2.09l-2.36,3.25,3.62-.09V27.3l-2.23,2.95H12.66l-1.46,2.6,9.63,3.33,6.66-3.71L25.22,30l-2.62-.17-1.35-2.25-.08-2.16,3.47-.09-2-3.12a10.29,10.29,0,0,0,1.47-2C36.68,17.23,38.23,4.15,38.23,4.15Zm-3.8,2.21A13,13,0,0,1,25.82,16a59.07,59.07,0,0,0,2.12-9.51ZM5.2,7.07,11,6.93A43.27,43.27,0,0,0,12.58,16,11.59,11.59,0,0,1,5.2,7.07Z"
						/>
						<polygon
							fill={tcs.highlight}
							points="37.88 4.43 37.68 5.25 28.2 5.29 28.2 4.8 37.88 4.43"
						/>
						<path
							fill={tcs.highlight}
							d="M22.34,21.33C26.92,14.65,27.7,3.19,27.7,3.19H11.39l.52.54L25.15,4C25.18,14.6,22.34,21.33,22.34,21.33Z"
						/>
						<polygon
							fill={tcs.highlight}
							points="1.77 5.46 10.76 5.21 10.76 5.62 1.89 6.03 1.77 5.46"
						/>
						<polygon
							fill={tcs.highlight}
							points="22.51 22.58 24.05 24.94 22 24.92 21.52 22.58 22.51 22.58"
						/>
						<polygon
							fill={tcs.shade}
							points="16.35 22.65 14.81 25.01 15.87 24.98 16.88 22.65 16.35 22.65"
						/>
						<polygon
							fill={tcs.shade}
							points="17.81 25.48 17.83 27.31 15.86 30.05 17.05 30.05 18.32 27.45 18.22 25.46 17.81 25.48"
						/>
						<polygon
							fill={tcs.highlight}
							points="20.85 25.48 20.87 27.58 22.27 30.05 21.08 30.05 20.41 27.63 20.57 25.49 20.85 25.48"
						/>
						<polygon
							fill={tcs.highlight}
							points="25.12 30.24 26.71 32.22 20.9 35.39 19.17 34.85 26.01 32.09 24.53 30.24 25.12 30.24"
						/>
						<path
							fill={tcs.shade}
							d="M13.39,16.63C14.71,20.15,16,21.26,16,21.26s-1.34-1.56-2.22-8.1a62.23,62.23,0,0,1-.5-8.67l-1.93,0S12,13,13.39,16.63Z"
						/>
						<path
							fill={tcs.shade}
							d="M12.94,30.73,12,32.55l5.77,2.06s-4.7-2.35-4.62-2.47.78-1.53.78-1.53Z"
						/>
						<path
							fill={tcs.shade}
							d="M3,7.19a19.67,19.67,0,0,0,4.39,7.15,10.89,10.89,0,0,0,5.6,3l-.16-.61a12.63,12.63,0,0,1-4.94-3,13.65,13.65,0,0,1-3.4-6.49Z"
						/>
						<path
							fill={tcs.highlight}
							d="M37.27,6.13S35.27,15,27.19,18c0,0,7.79-4.71,8.71-11.83Z"
						/>
					</g>
				</svg>
			);
		} else if (type === "trophy-unearned") {
			starImg = (
				<svg
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
					opacity={cs.opacity}
					className={styles.svg}
				>
					<g>
						<path
							opacity="0.6"
							fill={tcs.white}
							d="M38.2,4.1l-10,0.3c0.1-1.1,0.2-1.7,0.2-1.7H10.8c0,0,0,0.9,0.1,2.2L1.4,5.2 c0,0,1.1,12.5,13,15c0.5,0.8,1.1,1.5,1.8,2.1l-2.4,3.2l3.6-0.1v1.8l-2.2,2.9h-2.6l-1.5,2.6l9.6,3.3l6.7-3.7L25.2,30l-2.6-0.2 l-1.3-2.3l-0.1-2.2l3.5-0.1l-2-3.1c0.5-0.6,1-1.3,1.5-2C36.7,17.2,38.2,4.1,38.2,4.1z M34.4,6.4c0,0-1,7-8.6,9.7 c1.1-3.2,1.7-6.9,2.1-9.5L34.4,6.4z M5.2,7.1L11,6.9c0.2,2.6,0.6,6,1.6,9.1C5.9,13.4,5.2,7.1,5.2,7.1z"
						/>
					</g>
				</svg>
			);
		} else if (type === "planet") {
			if (celestialEarned) {
				starImg = (
					<svg
						viewBox="0 0 48 48"
						width="48"
						height="48"
						preserveAspectRatio="none"
						className={styles.svg}
					>
						<g>
							<path
								style={st4}
								d="M36.6,22.6c0,0.3,0.1,0.6,0.1,1C36.7,23.2,36.7,22.9,36.6,22.6z"
							/>
							<path
								style={st4}
								d="M36.7,23.8c0,0.2,0,0.5,0,0.7c0,0,0,0,0,0C36.7,24.2,36.7,24,36.7,23.8z"
							/>
							<path
								style={st4}
								d="M16.5,14.1c-0.1,0.1-0.3,0.2-0.4,0.3c0,0,0,0,0,0C16.2,14.4,16.3,14.2,16.5,14.1z"
							/>
							<path
								style={st4}
								d="M36.5,21.7C36.5,21.7,36.5,21.7,36.5,21.7c0,0.2,0.1,0.4,0.1,0.6C36.6,22.1,36.5,21.8,36.5,21.7z"
							/>
							<path
								style={st4}
								d="M18.4,12.9C18.4,12.9,18.4,12.9,18.4,12.9C18.4,12.9,18.4,12.9,18.4,12.9C18.4,12.9,18.4,12.9,18.4,12.9z"
							/>
							<path
								style={st1}
								d="M31.2,33.9C31.2,33.9,31.2,33.9,31.2,33.9c-0.1,0-0.2-0.1-0.3-0.1C31,33.8,31.1,33.9,31.2,33.9z"
							/>
							<path
								style={st1}
								d="M12,26.2c1.1,5.2,5.5,9.2,11.1,9.7c2.4,0.2,4.7-0.3,6.7-1.3c-1.6-0.5-6.1-2-9.6-3.7
			C16.6,29.4,13.8,27.7,12,26.2z"
							/>
							<path
								style={st1}
								d="M25.7,26.8c-0.3-0.1-0.6-0.2-0.8-0.4C25.1,26.6,25.4,26.7,25.7,26.8z"
							/>
							<path
								style={st1}
								d="M12.5,19.6c0.3,0.2,0.7,0.5,1.1,0.7C13.2,20.1,12.8,19.9,12.5,19.6C12.5,19.6,12.5,19.6,12.5,19.6z"
							/>
							<path
								style={st1}
								d="M16.5,14.1c-0.1,0.1-0.3,0.2-0.4,0.3c-1.3,1.1-2.3,2.4-3.1,4C15.3,20,25.2,26.3,35.5,29
			c0.6-1.2,1-2.6,1.2-4.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.2,0-0.5,0-0.7c0-0.1,0-0.1,0-0.2c0-0.3,0-0.7-0.1-1
			c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.6c-1-5.3-5.4-9.6-11.2-10.1c-2.5-0.2-4.8,0.3-6.9,1.3c0,0-0.1,0-0.1,0
			C17.9,13.2,17.2,13.6,16.5,14.1z"
							/>
							<path
								style={st4}
								d="M42.5,26.1c-0.1-0.1-0.3-0.3-0.5-0.4c-1.4-1.2-3-2.3-4.7-3.5c0.1,1.2,0,2.2-0.1,2.7c1.5,1.1,2.6,2,3.5,2.9
			c1.3,1.3,1.8,2.3,1.6,2.8c-0.4,0.8-3.1,0.8-7.4-0.3c-2.5-0.7-5.6-1.8-9.1-3.3c0,0-0.1,0-0.1-0.1c-0.3-0.1-0.6-0.2-0.8-0.4
			c-3.5-1.5-7.5-3.6-11.3-6.1c-0.4-0.2-0.7-0.5-1.1-0.7c-0.6-0.4-1.3-0.9-1.8-1.3c-3.3-2.6-4.2-4.2-3.9-4.8c0.2-0.4,1.1-0.7,3-0.5
			c0.8,0.1,1.9,0.2,3.1,0.5c0,0,0,0,0.1,0c0.8,0.2,1.6,0.4,2.5,0.7c0.4-0.4,1.1-1.1,2.1-1.7c-1.2-0.4-2.4-0.8-3.6-1.1
			C7.3,9.7,1.4,9,0.2,11.6c-1.4,3,4.1,8.3,11.5,13.1c1.3,0.8,2.7,1.7,4.1,2.5c3.2,1.7,8.1,4,15,6.6c0.1,0,0.2,0.1,0.3,0.1
			c2.4,0.8,4.6,1.4,6.7,1.7c0.9,0.2,1.8,0.3,2.7,0.4c2.9,0.3,6.3,0.1,7.2-1.7l0,0C48.9,31.9,45.3,28.4,42.5,26.1z"
							/>
							<path
								style={st4}
								d="M24.1,12.9c1.7-0.2,3.4,0.1,4.9,0.9c1.6,0.7,2.9,2,3.9,3.4c0.9,1.5,1.5,3.1,1.8,4.8c0.1,0.8,0.1,1.7,0.2,2.5
			c-0.1,0.8-0.1,1.7-0.2,2.5c-0.2-0.8-0.3-1.6-0.4-2.4c-0.2-0.8-0.4-1.6-0.6-2.3c-0.5-1.5-1-3-1.9-4.3
			C30.1,15.3,27.3,13.6,24.1,12.9z"
							/>
						</g>
					</svg>
				);
			} else {
				starImg = (
					<svg
						viewBox="0 0 48 48"
						width="48"
						height="48"
						preserveAspectRatio="none"
						className={styles.svg}
					>
						<g id="Common_Screeen_Elements">
							<path
								style={st3}
								d="M12,26.2c1.1,5.2,5.5,9.2,11.1,9.7c2.4,0.2,4.7-0.3,6.7-1.3c-1.6-0.5-6.1-2-9.6-3.7
		C16.6,29.4,13.8,27.7,12,26.2z"
							/>
							<path
								style={st3}
								d="M16.5,14.1c-0.1,0.1-0.3,0.2-0.4,0.3c-1.3,1.1-2.3,2.4-3.1,4C15.3,20,25.2,26.3,35.5,29
		c0.6-1.2,1-2.6,1.2-4.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.2,0-0.5,0-0.7c0-0.1,0-0.1,0-0.2c0-0.3,0-0.7-0.1-1
		c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.6c-1-5.3-5.4-9.6-11.2-10.1c-2.5-0.2-4.8,0.3-6.9,1.3c0,0-0.1,0-0.1,0
		C17.9,13.2,17.2,13.6,16.5,14.1z"
							/>
							<path
								style={st3}
								d="M42.5,26.1c-0.1-0.1-0.3-0.3-0.5-0.4c-1.4-1.2-3-2.3-4.7-3.5c0.1,1.2,0,2.2-0.1,2.7c1.5,1.1,2.6,2,3.5,2.9
		c1.3,1.3,1.8,2.3,1.6,2.8c-0.4,0.8-3.1,0.8-7.4-0.3c-2.5-0.7-5.6-1.8-9.1-3.3c0,0-0.1,0-0.1-0.1c-0.3-0.1-0.6-0.2-0.8-0.4
		c-3.5-1.5-7.5-3.6-11.3-6.1c-0.4-0.2-0.7-0.5-1.1-0.7c-0.6-0.4-1.3-0.9-1.8-1.3c-3.3-2.6-4.2-4.2-3.9-4.8c0.2-0.4,1.1-0.7,3-0.5
		c0.8,0.1,1.9,0.2,3.1,0.5c0,0,0,0,0.1,0c0.8,0.2,1.6,0.4,2.5,0.7c0.4-0.4,1.1-1.1,2.1-1.7c-1.2-0.4-2.4-0.8-3.6-1.1
		C7.3,9.7,1.4,9,0.2,11.6c-1.4,3,4.1,8.3,11.5,13.1c1.3,0.8,2.7,1.7,4.1,2.5c3.2,1.7,8.1,4,15,6.6c0.1,0,0.2,0.1,0.3,0.1
		c2.4,0.8,4.6,1.4,6.7,1.7c0.9,0.2,1.8,0.3,2.7,0.4c2.9,0.3,6.3,0.1,7.2-1.7l0,0C48.9,31.9,45.3,28.4,42.5,26.1z"
							/>
							<path
								style={st3}
								d="M24.1,12.9c1.7-0.2,3.4,0.1,4.9,0.9c1.6,0.7,2.9,2,3.9,3.4c0.9,1.5,1.5,3.1,1.8,4.8c0.1,0.8,0.1,1.7,0.2,2.5
		c-0.1,0.8-0.1,1.7-0.2,2.5c-0.2-0.8-0.3-1.6-0.4-2.4c-0.2-0.8-0.4-1.6-0.6-2.3c-0.5-1.5-1-3-1.9-4.3C30.1,15.3,27.3,13.6,24.1,12.9
		z"
							/>
						</g>
					</svg>
				);
			}
		} else if (type === "moon") {
			if (celestialEarned) {
				starImg = (
					<svg
						viewBox="0 0 48 48"
						width="48"
						height="48"
						preserveAspectRatio="none"
						className={styles.svg}
					>
						<g>
							<path
								style={st1}
								d="M28.6,27.9c-6.6,6.1-15.7,6.2-21.4,2.9c0.9,2,2.3,3.9,4,5.5c7.1,6.6,18.2,6.2,24.8-0.9s6.2-18.2-0.9-24.8
			C33.4,9,31.4,7.8,29.3,7C33,12.7,34.8,22.2,28.6,27.9z"
							/>
							<path
								style={st4}
								d="M33.1,10.9c2,3,3,6.7,2.6,10.4c-0.4,3.7-2.4,7.2-5.2,9.6c-2.7,2.5-6.2,4.2-9.9,4.6
			c-3.7,0.4-7.4-0.4-10.5-2.1c3.4,1.1,7,1.4,10.4,0.8c3.4-0.6,6.5-2.2,9-4.5c2.5-2.3,4.4-5.3,5-8.6C35.1,17.7,34.5,14.1,33.1,10.9z"
							/>
						</g>
					</svg>
				);
			} else {
				starImg = (
					<svg
						viewBox="0 0 48 48"
						width="48"
						height="48"
						preserveAspectRatio="none"
						className={styles.svg}
					>
						<g>
							<path
								style={st3}
								d="M28.6,27.9c-6.6,6.1-15.7,6.2-21.4,2.9c0.9,2,2.3,3.9,4,5.5c7.1,6.6,18.2,6.2,24.8-0.9s6.2-18.2-0.9-24.8
		C33.4,9,31.4,7.8,29.3,7C33,12.7,34.8,22.2,28.6,27.9z"
							/>
						</g>
					</svg>
				);
			}
		} else if (type === "comet") {
			if (celestialEarned) {
				starImg = (
					<svg
						viewBox="0 0 48 48"
						width="48"
						height="48"
						preserveAspectRatio="none"
						className={styles.svg}
					>
						<g>
							<path
								style={st4}
								d="M34.6,4.7c-17.4,2-26,19.3-26,19.3l5.8-1.9C6.7,29.2,1,43.4,1,43.4c12-8.8,21.1-11.6,21.1-11.6l-3.8,4.4
			c6.7-1.8,20.8-7.2,25.8-13c2.2-2.5,2.6-4.9,2.9-7.2C47.5,11.4,43.4,3.7,34.6,4.7z M13,32.5c-2.2,1.5-4.3,3-6.5,4.6
			c1.5-2.3,3.5-4.1,5.7-5.7c2.2-1.5,4.6-2.8,7.2-3.6C17.4,29.6,15.2,31,13,32.5z M42.1,22.5c-9.1,7.6-21.9,7.1-21.9,7.1
			c2-2,4.5-4.1,5.4-6.6c-3.9,0.6-9.1,2.2-12.6,5C19.7,6.8,32.7,6.5,33.8,6.3c2.9-0.5,6.6,0.1,8.9,2.4C46.5,12.5,46.2,19.1,42.1,22.5
			z"
							/>
							<path
								style={st1}
								d="M33.8,6.3C32.7,6.5,19.7,6.8,13,28c3.5-2.8,8.6-4.4,12.6-5c-0.9,2.5-3.4,4.6-5.4,6.6c0,0,12.8,0.5,21.9-7.1
			c4.1-3.4,4.4-10.1,0.6-13.8C40.4,6.5,36.7,5.8,33.8,6.3z M33.1,24.8c-0.8-0.1-1.6,0-2.3-0.3c-1.6-0.3-3-1.3-4-2.5
			c-1-1.3-1.5-2.9-1.6-4.5c-0.1-1.6,0.1-3.1,0.7-4.5c0,1.5,0.1,3,0.3,4.4c0.3,1.4,0.8,2.7,1.6,3.8c0.2,0.3,0.4,0.5,0.7,0.7
			c0.3,0.2,0.5,0.5,0.8,0.6l0.9,0.6c0.3,0.1,0.6,0.3,1,0.4c0.6,0.3,1.4,0.4,2.1,0.6c0.7,0.1,1.4,0.2,2.2,0.4
			C34.6,24.7,33.9,24.8,33.1,24.8z"
							/>
						</g>
					</svg>
				);
			} else {
				starImg = (
					<svg
						viewBox="0 0 48 48"
						width="48"
						height="48"
						preserveAspectRatio="none"
						className={styles.svg}
					>
						<g>
							<path
								style={st3}
								d="M34.10506,3.96646A23.65319,23.65319,0,0,0,22.57493,8.24168C9.61972,17.18078,6.4987,26.74122,6.4987,26.74122c3.53947-2.74309,6.0171-3.89342,9.46907-4.50791C5.47405,30.00644,1.717,44.12761,1.717,44.12761,8.5339,35.58989,20.37254,30.136,20.37254,30.136a9.89842,9.89842,0,0,1-3.87484,5.1c5.66519-1.39308,14.43677-4.13809,20.7804-7.978C44.08058,23.14017,46.283,18.2172,46.283,14.20108A10.80275,10.80275,0,0,0,34.10506,3.96646ZM31.83592,24.21964a11.174,11.174,0,0,1-2.23479-.639,7.04371,7.04371,0,0,1-3.5961-3.105,8.038,8.038,0,0,1-.91267-4.64372,10.19134,10.19134,0,0,1,1.38307-4.3549,20.49238,20.49238,0,0,0-.335,4.37848,8.75543,8.75543,0,0,0,1.04,3.96055,3.202,3.202,0,0,0,.55071.839,4.36218,4.36218,0,0,0,.67586.75022l.7695.68119c.30111.17334.59645.35877.89241.5515a17.92375,17.92375,0,0,0,1.9376.94184c.688.24516,1.39773.45136,2.10981.74175A21.76443,21.76443,0,0,1,31.83592,24.21964Z"
							/>
						</g>
					</svg>
				);
			}
		} else if (type === "galaxy") {
			if (celestialEarned) {
				starImg = (
					<svg
						viewBox="0 0 48 48"
						width="48"
						height="48"
						preserveAspectRatio="none"
						className={styles.svg}
					>
						<g>
							<path
								style={st1}
								d="M26.5,23c1.5-0.6,3-2.8,0-3.7c-4.2-1.3-12.2,1.9-15.2,4.7s-3.1,5.8-0.1,8.1c4.3,3.1,14.5,1.1,18.2,0.4
		c8.8-1.7,16.5-8.6,16.5-8.6s-10.1,5.4-17.5,6.7c-4.6,0.8-11.6,1.5-14.6,0.3c-3-1.2-2.9-4.6-1.7-5.9c1.2-1.3,2.8-2.1,2.8-2.1
		s-2.5,2.1-1.5,4.5c1,2.4,8.2,2.3,11.8,1.8c8.1-1.2,13.8-3.4,16.8-7.5c2.1-2.9,0.7-6.9-2.5-8.5c-7.1-3.8-18.8,0.4-18.8,0.4
		s8.8-1.3,13.7-0.1c3.5,0.9,4.7,2.5,5,4.7c0.3,2.3-1,5-5.2,7.3c-1.4,0.8-3.7,1.3-3.7,1.3s6.6-3.2,6.9-7.1c0.2-3.1-2.7-8.6-19.5-3.7
		c-6.2,1.8-12.2,5.8-12.2,5.8s9.1-4,13.7-5.1c4.9-1.2,10.2-1.7,12.6-1c2.1,0.6,4.4,2.2,3.4,5c-0.9,2.5-3.8,5-8.8,6.4
		c-5,1.5-10.3,1.1-10.4-1.6c0-2.7,2.2-4,5.2-4.8c1.8-0.5,3.7-0.1,4.3,0.3c-0.2,0-1.5-0.3-3.1,0.2c-2.2,0.7-3.5,2.6-3.2,3.7
		c0.5,1.5,4.6,2.7,10.1-0.4c5.1-2.8,5.2-6.4,2-7.4c-3.8-1.1-10.8-0.3-17,2.2c-6.2,2.5-10.4,6.7-10.9,9.9c-0.6,3.8,2,5.5,5.5,6.7
		c5.4,1.8,13-0.2,13-0.2S8.7,36.4,7.2,31.4c-0.5-1.7-0.9-4.9,3.3-8.2c3.5-2.7,7.9-4.7,12-5.2c4.1-0.5,7.3-0.3,8,1.3
		c0.7,1.6-1,3.6-2.4,4.3c-1.4,0.8-4,1.5-5.2,1c-1.2-0.5,0.3-2,0.3-2S24.2,23.9,26.5,23z"
							/>
							<polygon
								style={st1}
								points="45.5,17.8 47.7,16.5 46,18.4 47.4,20.6 45.4,19 43.2,20.3 44.9,18.4 43.6,16.2 	"
							/>
							<polygon
								style={st1}
								points="3.4,23.3 5.7,23.9 3.4,24.1 2.8,26.3 2.6,24 0.3,23.5 2.7,23.3 3.2,21 	"
							/>
							<polygon
								style={st1}
								points="18.5,13.1 19.6,11.9 18.9,13.4 20.2,14.6 18.6,13.9 17.5,15.2 18.2,13.6 16.9,12.5 	"
							/>
							<ellipse style={st3} cx="18.5" cy="13.5" rx="0.4" ry="0.4" />
							<ellipse style={st3} cx="45.5" cy="18.3" rx="0.7" ry="0.6" />
							<ellipse style={st3} cx="3" cy="23.7" rx="0.6" ry="0.5" />
							<path
								style={st3}
								d="M27.6,21.6c-0.5,1-1.9,1.4-2.8,1.2s-1.3-0.5-1.6-0.9c-1.3,0.5-2.4,2.1-1.5,2.8c2.2,1.7,7.5-0.9,7.5-0.9
		s-6,3.6-8.6,1.2c-1.2-1,0.1-2.5,1.4-3.2c1.3-0.7,3.3-1.1,4.3-0.5c-0.1-0.7-0.5-1.2-2.7-1.3c-2.4-0.1-6.6,1.5-6.6,1.5s3.2-2.5,8.2-2
		C26.8,19.6,28.1,20.7,27.6,21.6z"
							/>
							<path
								style={st3}
								d="M29.5,17.2c0.6,0,1.2,0.2,1.7,0.4c0.5,0.2,1.1,0.6,1.4,1.2c0.3,0.6,0.3,1.3,0,1.8c-0.1,0.3-0.3,0.5-0.4,0.8
			c-0.2,0.2-0.4,0.4-0.6,0.6c0.1-0.3,0.3-0.5,0.4-0.8c0.1-0.3,0.2-0.5,0.3-0.8c0.2-0.5,0.1-1-0.1-1.5c-0.2-0.4-0.6-0.8-1.1-1.1
			C30.5,17.7,30,17.4,29.5,17.2z"
							/>
							<path
								style={st3}
								d="M38.5,23.7c0.8-0.7,1.4-1.5,2-2.4c0.5-0.9,0.9-1.8,1-2.8c0.1-1-0.1-2-0.7-2.9l-0.2-0.3L40.4,15l-0.5-0.6
			c-0.3-0.4-0.7-0.7-1.1-1.1c0.4,0.3,0.8,0.6,1.3,1l0.5,0.6l0.3,0.3l0.2,0.3c0.6,0.9,0.9,2,0.8,3.1c-0.1,1.1-0.5,2.1-1.2,3
			C40.2,22.4,39.4,23.2,38.5,23.7z"
							/>
							<path
								style={st3}
								d="M15,24.8c-0.1,0.5-0.1,1,0,1.5c0.2,0.4,0.5,0.8,0.9,1.1c0.4,0.3,0.9,0.4,1.4,0.6c0.5,0.2,1,0.2,1.5,0.4
			c-0.3,0-0.5,0-0.8,0.1c-0.3,0-0.5,0-0.8-0.1c-0.5-0.1-1.1-0.2-1.6-0.5c-0.5-0.3-0.9-0.8-1-1.4C14.6,25.9,14.7,25.3,15,24.8z"
							/>
							<path
								style={st3}
								d="M6.3,26.2C6,27,5.9,27.7,5.8,28.4c-0.1,0.7-0.1,1.5,0,2.1c0.1,0.7,0.4,1.3,0.9,1.9c0.4,0.6,1,1.1,1.6,1.6
			c-0.4-0.1-0.7-0.3-1.1-0.5c-0.3-0.2-0.7-0.4-0.9-0.7c-0.3-0.3-0.5-0.6-0.7-1c-0.2-0.4-0.3-0.8-0.4-1.2C4.7,29.1,5.3,27.4,6.3,26.2
			z"
							/>
							<path
								style={st3}
								d="M16.4,32.4c1.4,0,2.8-0.1,4.1-0.2c1.4-0.1,2.7-0.2,4.1-0.4c1.4-0.2,2.7-0.4,4.1-0.7c1.4-0.2,2.7-0.6,4.1-0.9
			c-0.6,0.3-1.3,0.5-1.9,0.8c-0.7,0.2-1.3,0.4-2,0.6c-1.3,0.4-2.7,0.6-4.1,0.8c-1.4,0.2-2.8,0.3-4.2,0.3
			C19.2,32.7,17.8,32.7,16.4,32.4z"
							/>
						</g>
					</svg>
				);
			} else {
				starImg = (
					<svg
						viewBox="0 0 48 48"
						width="48"
						height="48"
						preserveAspectRatio="none"
						className={styles.svg}
					>
						<g>
							<path
								style={st3}
								d="M26.5,23c1.5-0.6,3-2.8,0-3.7c-4.2-1.3-12.2,1.9-15.2,4.7s-3.1,5.8-0.1,8.1c4.3,3.1,14.5,1.1,18.2,0.4
		c8.8-1.7,16.5-8.6,16.5-8.6s-10.1,5.4-17.5,6.7c-4.6,0.8-11.6,1.5-14.6,0.3c-3-1.2-2.9-4.6-1.7-5.9c1.2-1.3,2.8-2.1,2.8-2.1
		s-2.5,2.1-1.5,4.5c1,2.4,8.2,2.3,11.8,1.8c8.1-1.2,13.8-3.4,16.8-7.5c2.1-2.9,0.7-6.9-2.5-8.5c-7.1-3.8-18.8,0.4-18.8,0.4
		s8.8-1.3,13.7-0.1c3.5,0.9,4.7,2.5,5,4.7c0.3,2.3-1,5-5.2,7.3c-1.4,0.8-3.7,1.3-3.7,1.3s6.6-3.2,6.9-7.1c0.2-3.1-2.7-8.6-19.5-3.7
		c-6.2,1.8-12.2,5.8-12.2,5.8s9.1-4,13.7-5.1c4.9-1.2,10.2-1.7,12.6-1c2.1,0.6,4.4,2.2,3.4,5c-0.9,2.5-3.8,5-8.8,6.4
		c-5,1.5-10.3,1.1-10.4-1.6c0-2.7,2.2-4,5.2-4.8c1.8-0.5,3.7-0.1,4.3,0.3c-0.2,0-1.5-0.3-3.1,0.2c-2.2,0.7-3.5,2.6-3.2,3.7
		c0.5,1.5,4.6,2.7,10.1-0.4c5.1-2.8,5.2-6.4,2-7.4c-3.8-1.1-10.8-0.3-17,2.2c-6.2,2.5-10.4,6.7-10.9,9.9c-0.6,3.8,2,5.5,5.5,6.7
		c5.4,1.8,13-0.2,13-0.2S8.7,36.4,7.2,31.4c-0.5-1.7-0.9-4.9,3.3-8.2c3.5-2.7,7.9-4.7,12-5.2c4.1-0.5,7.3-0.3,8,1.3
		c0.7,1.6-1,3.6-2.4,4.3c-1.4,0.8-4,1.5-5.2,1c-1.2-0.5,0.3-2,0.3-2S24.2,23.9,26.5,23z"
							/>
							<polygon
								style={st3}
								points="45.5,17.8 47.7,16.5 46,18.4 47.4,20.6 45.4,19 43.2,20.3 44.9,18.4 43.6,16.2 	"
							/>
							<polygon
								style={st3}
								points="3.4,23.3 5.7,23.9 3.4,24.1 2.8,26.3 2.6,24 0.3,23.5 2.7,23.3 3.2,21 	"
							/>
							<polygon
								style={st3}
								points="18.5,13.1 19.6,11.9 18.9,13.4 20.2,14.6 18.6,13.9 17.5,15.2 18.2,13.6 16.9,12.5 	"
							/>
							<ellipse style={st3} cx="18.5" cy="13.5" rx="0.4" ry="0.4" />
							<ellipse style={st3} cx="45.5" cy="18.3" rx="0.7" ry="0.6" />
							<ellipse style={st3} cx="3" cy="23.7" rx="0.6" ry="0.5" />
							<path
								style={st3}
								d="M27.6,21.6c-0.5,1-1.9,1.4-2.8,1.2s-1.3-0.5-1.6-0.9c-1.3,0.5-2.4,2.1-1.5,2.8c2.2,1.7,7.5-0.9,7.5-0.9
		s-6,3.6-8.6,1.2c-1.2-1,0.1-2.5,1.4-3.2c1.3-0.7,3.3-1.1,4.3-0.5c-0.1-0.7-0.5-1.2-2.7-1.3c-2.4-0.1-6.6,1.5-6.6,1.5s3.2-2.5,8.2-2
		C26.8,19.6,28.1,20.7,27.6,21.6z"
							/>
							<path
								style={st3}
								d="M29.5,17.2c0.6,0,1.2,0.2,1.7,0.4c0.5,0.2,1.1,0.6,1.4,1.2c0.3,0.6,0.3,1.3,0,1.8c-0.1,0.3-0.3,0.5-0.4,0.8
			c-0.2,0.2-0.4,0.4-0.6,0.6c0.1-0.3,0.3-0.5,0.4-0.8c0.1-0.3,0.2-0.5,0.3-0.8c0.2-0.5,0.1-1-0.1-1.5c-0.2-0.4-0.6-0.8-1.1-1.1
			C30.5,17.7,30,17.4,29.5,17.2z"
							/>
							<path
								style={st3}
								d="M38.5,23.7c0.8-0.7,1.4-1.5,2-2.4c0.5-0.9,0.9-1.8,1-2.8c0.1-1-0.1-2-0.7-2.9l-0.2-0.3L40.4,15l-0.5-0.6
			c-0.3-0.4-0.7-0.7-1.1-1.1c0.4,0.3,0.8,0.6,1.3,1l0.5,0.6l0.3,0.3l0.2,0.3c0.6,0.9,0.9,2,0.8,3.1c-0.1,1.1-0.5,2.1-1.2,3
			C40.2,22.4,39.4,23.2,38.5,23.7z"
							/>
							<path
								style={st3}
								d="M15,24.8c-0.1,0.5-0.1,1,0,1.5c0.2,0.4,0.5,0.8,0.9,1.1c0.4,0.3,0.9,0.4,1.4,0.6c0.5,0.2,1,0.2,1.5,0.4
			c-0.3,0-0.5,0-0.8,0.1c-0.3,0-0.5,0-0.8-0.1c-0.5-0.1-1.1-0.2-1.6-0.5c-0.5-0.3-0.9-0.8-1-1.4C14.6,25.9,14.7,25.3,15,24.8z"
							/>
							<path
								style={st3}
								d="M6.3,26.2C6,27,5.9,27.7,5.8,28.4c-0.1,0.7-0.1,1.5,0,2.1c0.1,0.7,0.4,1.3,0.9,1.9c0.4,0.6,1,1.1,1.6,1.6
			c-0.4-0.1-0.7-0.3-1.1-0.5c-0.3-0.2-0.7-0.4-0.9-0.7c-0.3-0.3-0.5-0.6-0.7-1c-0.2-0.4-0.3-0.8-0.4-1.2C4.7,29.1,5.3,27.4,6.3,26.2
			z"
							/>
							<path
								style={st3}
								d="M16.4,32.4c1.4,0,2.8-0.1,4.1-0.2c1.4-0.1,2.7-0.2,4.1-0.4c1.4-0.2,2.7-0.4,4.1-0.7c1.4-0.2,2.7-0.6,4.1-0.9
			c-0.6,0.3-1.3,0.5-1.9,0.8c-0.7,0.2-1.3,0.4-2,0.6c-1.3,0.4-2.7,0.6-4.1,0.8c-1.4,0.2-2.8,0.3-4.2,0.3
			C19.2,32.7,17.8,32.7,16.4,32.4z"
							/>
						</g>
					</svg>
				);
			}
		}
		return starImg;
	},

	render: function() {
		const {className, shadowOffset, onClick, clickSound, linkTo} = this.props;

		const imgEl = this.makeImg();
		const shadowEl = this.makeImg(true);

		let mainClass = this.props.showHoverEffect
			? styles.main
			: styles.mainNoHighlight;
		if (className) mainClass += " " + className;
		mainClass += " " + styles["main" + shadowOffset];

		const shadowStyle = {
			marginLeft: shadowOffset,
			marginTop: shadowOffset,
		};

		// Keeping hover div in case we want different hover effect
		if (linkTo) {
			return (
				<StudentLink
					to={linkTo}
					className={mainClass}
					clickAction={onClick}
					clickSound={clickSound}
					useWonkyCursor={true}
				>
					<div
						onMouseEnter={this.onHoverStart}
						onMouseLeave={this.onHoverEnd}
					/>
					<div className={styles.shadow} style={shadowStyle}>
						{shadowEl}
					</div>
					<div className={styles.img}>{imgEl}</div>
				</StudentLink>
			);
		} else {
			const onClickWithSound = () => {
				clickSound && Sounds.playSound(clickSound);
				onClick && onClick();
			};
			return (
				<div className={mainClass} onClick={onClickWithSound}>
					<div
						onMouseEnter={this.onHoverStart}
						onMouseLeave={this.onHoverEnd}
					/>
					<div className={styles.shadow} style={shadowStyle}>
						{shadowEl}
					</div>
					<div className={styles.img}>{imgEl}</div>
				</div>
			);
		}
	},
});
